import api from '../../ApiConfig';
import { Apis } from '../../config';
import { Alerts } from '..';
var token = localStorage.getItem('userToken');
const getAllUser = async ({ search = '', page = 1, limit = 10, startDate, endDate, userStatus }) => {
  try {
      const params = new URLSearchParams({
      page: page.toString(),
      limit: limit.toString()
    });
    
    if (search) params.append('search', search);
    if (startDate) params.append('startDate', startDate);
    if (endDate) params.append('endDate', endDate);
    if (userStatus || userStatus === 0) params.append('userStatus', userStatus);
    let result = await api.get(`${Apis.GetAllUsers}?${params.toString()}`, {
        headers: {
          'x-access-token': token
        }
      });
    if (result.data.error) {
      return null;
    }
    return result.data;
  } catch (error) {
    if (error.response) {
      return error.response.data;
    }
    return null;
  }
};
const getSinlgeUser = async (id) => {
  try {
    let result = await api.get(Apis.GetSinleUser+id, {
        headers: {
          'x-access-token': token
        }
      });
    if (result.data.error) {
      return null;
    }
    return result.data;
  } catch (error) {
    if (error.response) {
      return error.response.data;
    }
    return null;
  }
};
const updateUserAddress = async (id,data) => {
  try {
        var token = localStorage.getItem('userToken');
    let result = await api.put(Apis.UpdateUserAddress+id, data, {
      headers: {
        'x-access-token': token
      }
    });
    if (result.data.error) {
      return null;
    }
    return result.data;

  } catch (error) {
    if (error.response) {
      return error.response.data;
    }
    return null;
  }
}
const addNewUser = async (data) => {
  try {
    var token = localStorage.getItem('userToken');
    let result = await api.post(Apis.AddNewUser, data,{
      headers: {
        'x-access-token': token
      }
    });
  if (result.data.error) {
      return null;
    }
    return result.data;
  } catch (error) {
   // Safely check for 422 status code
    if (error.response && error.response.status === 422) {
      Alerts.alertMessage(error.response.data.message, 'top-right', 'error');
    } else {
      Alerts.alertMessage('Something went wrong!', 'top-right', 'error');
    }

    console.error(error);
    return null; // Ensure consistent return type
  }
}
const updateCustomer = async (data) => {
  try {
    var token = localStorage.getItem('userToken');
    let result = await api.post(Apis.UpdateCustomer, data,{
      headers: {
        'x-access-token': token
      }
    });
  if (result.data.error) {
      return null;
    }
    return result.data;
  } catch (error) {
   // Safely check for 422 status code
    if (error.response && error.response.status === 422) {
      Alerts.alertMessage(error.response.data.message, 'top-right', 'error');
    } else {
      Alerts.alertMessage('Something went wrong!', 'top-right', 'error');
    }

    console.error(error);
    return null; // Ensure consistent return type
  }
}



const resentOtp = async (data) => {
  try {
    var token = localStorage.getItem('userToken');
    let result = await api.post(Apis.ResendOtp, data,{
      headers: {
        'x-access-token': token
      }
    });
  if (result.data.error) {
      return null;
    }
    return result.data;
  } catch (error) {
   // Safely check for 422 status code
    if (error.response && error.response.status === 422) {
      Alerts.alertMessage(error.response.data.message, 'top-right', 'error');
    } else {
      Alerts.alertMessage('Something went wrong!', 'top-right', 'error');
    }

    console.error(error);
    return null; // Ensure consistent return type
  }
}


const verifyNewUser = async (data) => {
  try {
    var token = localStorage.getItem('userToken');
    let result = await api.post(Apis.VerifyNewUser, data,{
      headers: {
        'x-access-token': token
      }
    });
     if (result.data.error) {
      return null;
    }
    return result.data;
  } catch (error) {
    if(error.status === 422){
      Alerts.alertMessage(error.response.data.message, 'top-right', 'error');
    }
     if(error.status === 400){
      Alerts.alertMessage(error.response.data.message, 'top-right', 'error');
    }
    if(error.status === 404){
      Alerts.alertMessage(error.response.data.message, 'top-right', 'error');
    }
    console.log(error);
    return null;
  }
}
const exportUsers = async (data) => {
  try {
    var token = localStorage.getItem('userToken');
    let result = await api.get(Apis.ExportUsers,{
       responseType: 'blob',
      headers: {
        'x-access-token': token
      }
    });
     if (result.data.error) {
      return null;
    }
    return result.data;
  } catch (error) {
    return null;
  }
}


const importUsers = async (formData) => {
  try {
    const token = localStorage.getItem('userToken');

    const response = await api.post(Apis.ImportUsers, formData, {
      headers: {
        'x-access-token': token,
        'Content-Type': 'multipart/form-data',
      }
    });

    return {
      success: true,
      data: response.data
    };

  } catch (error) {
    // Catch both API and network errors
    if (error.response && error.response.data) {
      return {
        success: false,
        error: {
          message: error.response.data.message,
          errors: error.response.data.errors || []
        }
      };
    } else {
      return {
        success: false,
        error: {
          message: 'Something went wrong. Please try again.',
          errors: []
        }
      };
    }
  }
};
const searchUserByEmail = async (q) => {
  try {
    let result = await api.get(`${Apis.SearchUserByEmail}?q=${q}`, {
        headers: {
          'x-access-token': token
        }
      });
    if (result.data.error) {
      return null;
    }
    return result.data;
  } catch (error) {
    if (error.response) {
      return error.response.data;
    }
    return null;
  }
};
const addNewAddress = async (userId, data) => {
  try {
    var token = localStorage.getItem('userToken');
    let result = await api.post(Apis.AddNewAddress+userId, data,{
      headers: {
        'x-access-token': token
      }
    });
     if (result.data.error) {
      return null;
    }
    return result.data;
  } catch (error) {
    return null;
  }
}


const exportedObject = {
    getAllUser,
    updateUserAddress,
    addNewUser,
    resentOtp,
    verifyNewUser,
    exportUsers,
    importUsers,
    searchUserByEmail,
    addNewAddress,
    getSinlgeUser,
    updateCustomer
};
export default exportedObject;